import { render } from "./RouletteSelectorPropsCmp.vue?vue&type=template&id=1b410c8d"
import script from "./RouletteSelectorPropsCmp.vue?vue&type=script&lang=js"
export * from "./RouletteSelectorPropsCmp.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__